<template>
    <span v-html="telephoneNumber"></span>
</template>

<script>
import {telephoneNumberFormat} from '@/shared/Utilities'

export default {
        name: 'TelephoneNumber',

        created() {
            // This logic assumes that all phone numbers are US or Canada
            this.telephoneNumber = telephoneNumberFormat(this.phoneNumber)
        },

        data() {
            return {
                telephoneNumber: '',
            }
        },

        props: {
            phoneNumber: {
                type: String,
                required: true,
            },
            clickable: {
                type: Boolean,
                default: true,
            },
        },
    }
</script>